import { useState, type ReactNode } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

type Snap = 'peek' | 'half' | 'full';

export function MobileBottomSheet({ children }: { children: ReactNode }) {
  const [snap, setSnap] = useState<Snap>('peek');
  const heights: Record<Snap, string> = { peek: '64px', half: '50dvh', full: '85dvh' };
  const next: Record<Snap, Snap> = { peek: 'half', half: 'full', full: 'peek' };

  return (
    <div
      style={{ height: heights[snap] }}
      className="fixed inset-x-0 bottom-0 z-20 flex flex-col rounded-t-2xl border border-[var(--border)] bg-[var(--theme)] transition-[height] duration-200 sm:hidden"
    >
      <button
        type="button"
        onClick={() => setSnap(next[snap])}
        className="flex h-12 w-full items-center justify-center text-[var(--secondary)]"
        aria-label={`Expand to ${next[snap]}`}
      >
        {snap === 'full' ? <ChevronDown /> : <ChevronUp />}
      </button>
      <div className="flex-1 overflow-auto">{children}</div>
    </div>
  );
}
